import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Messages from './Messages';
import './ChatWidget.scss';

const ChatWidget = () => {
    const jwtToken = useSelector((state) => state.auth.jwtToken);
    const user = useSelector((state) => state.auth.user);

    // Widget state: minimized bar vs expanded panel
    const [isMinimized, setIsMinimized] = useState(true);

    const userAvatar = user?.image || user?.avatar || null;
    const userInitial = (user?.display_name || user?.user_email || 'M').charAt(0).toUpperCase();

    if (!jwtToken) {
        return null;
    }

    return (
        <div className="octopus-chat-widget">
            {/* Screen 1: Minimized bar - fixed bottom right */}
            
            <div className="octopus-chat-widget-panel-main">
                <div className="octopus-chat-widget-panel-body">
                    {/* Full Messages experience (list + ChatPanel + new message), reused as a widget */}
                    <Messages isWidget={true} onCloseWidget={() => setIsMinimized(true)} />
                </div>
            </div>
        </div>
    );
};

export default ChatWidget;
